export default function BookingTermsContentEn() {
  const p = "text-sm text-dark leading-relaxed mb-3";
  const ulMain = "list-none space-y-4 mb-4 pl-0";
  const liBullet = "text-sm text-dark leading-relaxed";
  const subUl = "list-none space-y-3 mt-2 pl-4 border-l-2 border-gray-200";
  const subLi = "text-sm text-dark leading-relaxed";

  return (
    <div className="px-1">
      <p className="text-base font-bold text-dark mb-1">
        Terms and Conditions for Safety Riding Training
      </p>
      <p className="text-sm text-dark mb-6">
        Honda Safety Riding Center
      </p>

      <hr className="border-gray-200 mb-6" />

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3">1. Safety Standards and Preparedness</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.1 Physical Condition:</p>
          <p className={p}>
            Trainees must be in good physical and mental health. Any pre-existing medical conditions or physical limitations must be disclosed to staff prior to the training.
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.2 Attire and Discipline:</p>
          <p className={p}>
            Proper riding attire as specified by the center is mandatory. Trainees must strictly follow the instructor&apos;s guidance at all times.
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.3 Punctuality:</p>
          <p className={p}>
            Trainees must arrive on time. The center reserves the right to refuse entry to those who arrive late.
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 1.4 Readiness Assessment and Course Adjustment:</p>
          <p className={p}>
            For the safety of all participants, the Center reserves the right for instructors to assess each trainee&apos;s readiness. The Center may modify, adjust, or cancel the training course if a trainee is deemed unprepared or poses a potential safety risk during the training.
          </p>
        </li>
      </ul>

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">2. Rules and Prohibited Conduct</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 2.1 Intoxicants:</p>
          <p className={p}>
            Alcohol, illegal drugs, and gambling are strictly prohibited within the center&apos;s premises.
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 2.2 Smoking:</p>
          <p className={p}>
            Smoking is only permitted in designated areas. Smoking inside buildings or on the track is strictly forbidden.
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 2.3 Legal Compliance:</p>
          <p className={p}>
            Trainees without a valid license or under the age of 15 are strictly prohibited from operating vehicles on public roads or highways.
          </p>
        </li>
      </ul>

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">3. Insurance &amp; Liability</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 3.1 Accident Insurance Coverage:</p>
          <ul className={subUl}>
            <li className={subLi}>
              <p className={p}>
                <span className="font-medium">○ </span>
                The Center provides group accident insurance for trainees covering only accidents occurring on the training track during the scheduled training sessions. Coverage is limited to medical expenses up to the amount specified in the insurance policy. Trainees shall not be entitled to claim any additional compensation beyond such coverage.
              </p>
            </li>
          </ul>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 3.2 Exclusions (What is not covered):</p>
          <ul className={subUl}>
            <li className={subLi}>
              <p className="font-medium mb-1">○ Off-site Accidents:</p>
              <p className={p}>
                Accidents occurring during travel to/from the center or occurring outside the designated training area.
              </p>
            </li>
            <li className={subLi}>
              <p className="font-medium mb-1">○ High-risk Behavior &amp; Rule Violations:</p>
              <p className={p}>
                Accidents resulting from intentional misconduct, reckless riding, or being under the influence of alcohol or drugs.
              </p>
            </li>
            <li className={subLi}>
              <p className="font-medium mb-1">○ Pre-existing Conditions:</p>
              <p className={p}>
                Illnesses or injuries arising from the trainee&apos;s pre-existing medical conditions, including any prohibited diseases or conditions under the regulations of the Department of Land Transport that disqualify a person from obtaining a driving license.
              </p>
            </li>
            <li className={subLi}>
              <p className="font-medium mb-1">○ Property Damage:</p>
              <p className={p}>
                Insurance covers only bodily injury. It does not cover damage to personal vehicles or personal valuables (e.g., phones, watches).
              </p>
            </li>
          </ul>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 3.3 Waiver of Liability:</p>
          <p className={p}>
            In the event of gross negligence, the trainee agrees to be solely responsible for all damages to themselves and the center&apos;s property.
          </p>
        </li>
      </ul>

      <h2 className="text-base sm:text-lg font-bold text-dark mb-3 mt-6">4. Company Rights and PDPA</h2>
      <ul className={ulMain}>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.1 Schedule Adjustments:</p>
          <p className={p}>The center reserves the right to change or cancel training schedules as appropriate.</p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.2 Media and Data Rights:</p>
          <p className={p}>
            Trainees consent to the Center recording photographs, videos, and related information during the training and using or publishing such materials for the Center&apos;s public relations purposes in accordance with the PDPA policy.
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.3 Data Transfer to the Department of Land Transport:</p>
          <p className={p}>
            Trainee agrees and consents to the training center transferring the trainee&apos;s training results and relevant personal data to the Department of Land Transport for the purpose of processing or facilitating matters relating to the issuance of the trainee&apos;s driving license.
          </p>
        </li>
        <li className={liBullet}>
          <p className="font-medium mb-1">● 4.4 Operational Purpose:</p>
          <p className={p}>
            Trainee agrees and consents to the training center collecting and using the trainee&apos;s personal data for operational purposes related to the training services.
          </p>
        </li>
      </ul>
    </div>
  );
}